var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-video",attrs:{"id":"my-video"}},[(_vm.show)?_c('VideoShow',{staticClass:"video",attrs:{"videoUrl":_vm.videoUrl,"token":_vm.token}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }